export namespace StockTriggerTranslations {
  export const parse = {
    parseStockTriggerTitle: 'parseStockTriggerTitle',
    parseStockTriggerSuccessfull: 'parseStockTriggerSuccessfull',
    parseStockTriggerFailed: 'parseStockTriggerFailed',

    parseStockTriggerMissingProductNumber: 'parseStockTriggerMissingProductNumber',
    parseStockTriggerMissingReorderQuantity: 'parseStockTriggerMissingReorderQuantity',
    parseStockTriggerMissingReplenishQuantity: 'parseStockTriggerMissingReplenishQuantity',
  } as const;
}
